import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Alert } from 'reactstrap';
import LogInForm from './components/LogInForm';
import { useAuth } from '../../contexts/AuthContext';

const LogIn = () => {
  const {
    login,
    loading,
    error,
    isAuthenticated,
    clearInvalidTokens,
  } = useAuth();
  const history = useHistory();
  const location = useLocation();

  // Check for success message from email confirmation
  const successMessage = location.state?.message;

  // Check authentication state on component mount
  useEffect(() => {
    const checkExistingAuth = async () => {
      if (isAuthenticated) {
        // Redirect to the original URL if available
        const { from } = location.state || { from: { pathname: '/' } };
        history.replace(from);
      } else {
        // Check if there are any existing tokens and validate them
        await clearInvalidTokens();
      }
    };

    checkExistingAuth();
  }, [isAuthenticated, history, clearInvalidTokens]);

  const onSubmitLoginForm = async (email, password) => {
    const result = await login(email, password);

    if (result.success) {
      // Redirect to the intended page or dashboard
      const { from } = location.state || { from: { pathname: '/' } };
      history.replace(from);
    }
  };

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">Welcome to
              <span className="account__logo"> Revenue
                <span className="account__logo-accent">OS</span>
              </span>
            </h3>
            <h4 className="account__subhead subhead">Accelerate your revenue growth</h4>
          </div>

          {successMessage && (
            <Alert color="success" className="mb-3">
              {successMessage}
            </Alert>
          )}

          <LogInForm onSubmit={onSubmitLoginForm} loading={loading} error={error} />

          <div className="account__help mt-3">
            <p className="text-center">
              Need to confirm your email?{' '}
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => history.push('/confirm-email')}
              >
                Click here
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/component/form.scss to add styles
